<template>
	<div class="page">
		<div class="filter-condition box-shadow-small border-radius">
			<multi-search :fields="multiFields" mode="cover"></multi-search>
		</div>
		<div class="filter-result background-white box-shadow-small border-radius">
			<div v-loading="partialLoading">
				<empty-tip :show="!lists.length"></empty-tip>
				<div class="table-list mt-20">
					<el-table v-if="lists.length" :data="lists">
						<!-- <el-table-column type="selection" align="center" width="50" /> -->
						<el-table-column label="姓名" show-overflow-tooltip align="center" fixed min-width="80">
							<template slot-scope="scope">{{ scope.row.resumeForm.name }}</template>
						</el-table-column>
            <el-table-column label="岗位" class-name="no-wrap" align="center" fixed min-width="100">
							<template slot-scope="scope">
								<el-tooltip
									effect="dark"
									:content="getPositionTipText(scope.row)"
									placement="top"
									v-if="scope.row.oldPositionName || scope.row.newPositionName"
								>
									<el-button type="text" icon="el-icon-my-xinxi"></el-button>
								</el-tooltip>
								<span :title="scope.row.positionForm.name">{{ scope.row.positionForm.name }}</span>
							</template>
						</el-table-column>
            <el-table-column prop="proName" label="所属项目" show-overflow-tooltip align="center" fixed min-width="100" />
						<el-table-column prop="resumeForm.gender" label="性别" show-overflow-tooltip align="center" min-width="70">
							<template slot-scope="scope">{{{1: '男', 2: '女'}[scope.row.resumeForm.gender] || '-'}}</template>
						</el-table-column>
						<el-table-column prop="resumeForm.mobilePhone" label="手机" show-overflow-tooltip align="center" min-width="110" />
						<el-table-column prop="resumeForm.email" label="邮箱" show-overflow-tooltip align="center" min-width="110" />
						<el-table-column label="最高学历" align="center" show-overflow-tooltip min-width="80">
							<template slot-scope="scope">
                {{ getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree) }}
              </template>
						</el-table-column>
						<el-table-column label="最高学历学校" align="center" show-overflow-tooltip min-width="100">
							<template slot-scope="scope">
								<el-tag type="primary" v-if="scope.row.resumeForm.schoolType ==='1'">985</el-tag>
								<el-tag type="success" v-else-if="scope.row.resumeForm.schoolType ==='2'">211</el-tag>
								{{ scope.row.resumeForm.resumeMaxEducation.school }}
							</template>
						</el-table-column>
						<el-table-column prop="resumeForm.resumeMaxEducation.major" label="专业" show-overflow-tooltip align="center" min-width="140" />
            <el-table-column prop="positionForm.mark" label="招聘HR" show-overflow-tooltip align="center" min-width="140" />
						<el-table-column label="应聘城市" :show-overflow-tooltip="true" align="center" min-width="90">
							<template
								slot-scope="scope"
							>{{ getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)}}</template>
						</el-table-column>
            <el-table-column v-if="!isSchool" label="游戏经验" :show-overflow-tooltip="true" align="center" min-width="90">
							<template slot-scope="scope">{{ scope.row.resumeForm.gameExperience }}</template>
						</el-table-column>
            <el-table-column label="简历附件" align="center" width="120">
							<template slot-scope="scope">
								<attach-view-in-list :attachList="scope.row.resumeForm.resumeAttachList" />
							</template>
						</el-table-column>
            <el-table-column align="center" label="投递时间" show-overflow-tooltip min-width="100">
							<template slot-scope="scope">{{dateFormat(scope.row.commitTime)}}</template>
						</el-table-column>
            <el-table-column label="状态" align="center" min-width="130">
							<template slot-scope="scope">
								<el-tooltip v-if="scope.row.operateReason" effect="dark" :content="scope.row.operateReason" placement="top-start">
									<el-button type="text" icon="el-icon-my-xinxi">{{getStatusText(scope.row)}}</el-button>
								</el-tooltip>
								<span v-else>{{getStatusText(scope.row)}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="resumeForm.remark" show-overflow-tooltip label="备注" align="center" min-width="120" />
						<el-table-column prop="resumeForm.remark" show-overflow-tooltip label="最近操作人" align="center" min-width="130">
							<template slot-scope="scope">
								<div style="font-size: 12px;">
									<p>{{scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''}}</p>
									<p>{{scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)}}</p>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-pagination
					v-if="lists.length"
					class="text-center mb-20 mt-10"
					@size-change="pageSizeChange"
					@current-change="pageIndexChange"
					:current-page="pagination.pageIndex"
					:page-size="pagination.pageSize"
					:page-sizes="[20, 50, 100, 200]"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.recordCounts"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import QueryListExtend from 'components/queryListExtend'
import MultiSearch from 'views/common/multiSearch'
import manualPopoverMixin from 'mixins/manualPopoverMixin'
import resumeMixin from '../resume/resumeMixin'
import AttachViewInList from '../operation/attachViewInList.vue'
import { dateFormat } from 'modules/tools'

export default {
    extends: QueryListExtend,
    mixins: [ resumeMixin, manualPopoverMixin ],
    components: { MultiSearch, manualPopoverMixin, AttachViewInList },
    data() {
        return {
            fetchUrl: '/resume/repeat/list.api',
            multiFields: [
                {
                    filter: '',
                    label: '姓名',
                    mode: 'input',
                    name: 'nameSearch',
                },
                {
                    filter: '',
                    label: '手机号',
                    mode: 'input',
                    name: 'mobilePhoneSearch',
                },
                {
                    filter: '',
                    label: '邮箱',
                    mode: 'input',
                    name: 'emailSearch',
                },
            ],
        }
    },
    computed: {
        isSchool () {
            return this.$store.state.user.property === '0'
        }
    },
    methods: {
        dateFormat(date, format = 'yyyy/MM/dd') {
            return dateFormat(date, format)
        },
        resetSearchDateBeforeFetch () {
            const { nameSearch = '', mobilePhoneSearch = '', emailSearch = '' } = this.searchData
            if(!nameSearch.trim() && !mobilePhoneSearch.trim() && !emailSearch.trim()) {
                this.firstRendered = true
                this.partialLoading = false
                this.lists = []
                return false
            } else {
                return true
            }
        },
        getPositionTipText(row) {
            const { oldPositionName, newPositionName, isJobTransfer } = row

            if (isJobTransfer == 1 && newPositionName) {
                // 已转岗
                return `已转岗到${newPositionName}职位`
            } else {
                // 最新数据
                return `转岗前：${oldPositionName}职位`
            }
        },
        getStatusText(row) {
            if (row.isJobTransfer == 1) {
                return '已转岗'
            }

            return this.getSelectMapText('WB_FLOW_STATUS', row.status)
        }
    },
}
</script>

<style lang="scss" scoped>
.page /deep/ .el-table__body-wrapper{
	overflow-x: scroll;
}
</style>


// WEBPACK FOOTER //
// index.vue?12ea75f2